import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getHubspotWebhookTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'url-suffix',
			selector: '[data-tour="url-suffix"]',
			content:
				'Required: This is used to append a suffix to your base URL to create an endpoint in the environment. Note that the base URL is determined by the environment.',
		},
		{
			id: 'http-url',
			selector: '[data-tour="http-url"]',
			content:
				'This setting cannot be adjusted and is solely used to show the final endpoint after the suffix has been setup in 4. There is also a copy button for ease of copying the URL to your clipboard. The URL is constructed as follows: {Base URL} + "api/microservice/REST" + {The Flow Name} + {The Flow Version} + {The Suffix}.',
		},
		{
			id: 'hs-client-secret',
			selector: '[data-tour="hs-client-secret"]',
			content: 'Required: The HubSpot client secret that will be used to validate the request.',
		},
		{
			id: 'is-sync',
			selector: '[data-tour="is-sync"]',
			content:
				'Required: Sets whether the task needs to send a response back to the source (Synchronous) vs. not sending a response back to the source (Asynchronous).',
		},
		{
			id: 'consolidate-event',
			selector: '[data-tour="consolidate-event"]',
			content:
				'Required: For some HubSpot events, HubSpot will create multiple REST API requests (i.e. when creating an item, both the create event and update events for all the populated values would be sent). By enabling this property, iHub will attempt to consolidate these events into a single event if the batch of related events arrive at the same time. This makes for less cluttered flow runs.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
